import { render } from "./RolesManagement.vue?vue&type=template&id=5a22e7ea"
import script from "./RolesManagement.vue?vue&type=script&lang=js"
export * from "./RolesManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__